import { FunctionComponent } from "react";

const Home: FunctionComponent = () => {

    return (
        <div className="page-container">

            <div className="logo" />

            <div className="tick-wrapper">
                <div className="tick-circle">
                    <div className="tick-checkMark"></div>
                </div>
            </div>

            <h3>Welcome! You are now logged in!</h3>
            <p>To stay signed in, please keep this popup open (minimized). Your session will refresh automatically in the background.<br></br>
                You can now start using Sidekick!</p>

        </div>
    );
}

export default Home;